import React, { useEffect, useState } from "react";
import editarIcon from "../../../../../../../assets/icons/editar.svg";
import editarWhiteIcon from "../../../../../../../assets/icons/editar_white.svg";
import checkIcon from "../../../../../../../assets/icons/check.svg";
import { greenIcons } from "../../../../../../../utils/icons";
import { useModal } from "../../../../../../../hooks/ModalContext";
import { useCheckBoxCadastro } from "../../../../../../../hooks/CheckboxCadastroContext";
import { useDividas } from "../../../../../../../context/DividasContext";
import { useCadastro } from "../../../../../../../context/CadastroContext";
import { AtualizaEmailProps } from "../../../../../../../types/email-atualiza-interface";

export const TabelaEmail = () => {
  const { setModal, getInfoEmail } = useModal();
  const { isTodosChecked } = useCheckBoxCadastro()
  const { devedorCadastro } = useDividas()
  const { emails } = useCadastro()
  const [checkboxes, setCheckboxes] = useState([
    { id: 1, checked: false },
    { id: 2, checked: false },
    { id: 3, checked: false },
    { id: 4, checked: false },
    { id: 5, checked: false },
    { id: 6, checked: false },
  ])

  const handleCheckboxToggle = (checkboxId: number) => {
    const updatedCheckboxes = checkboxes.map((checkbox) =>
      checkbox.id === checkboxId
        ? { ...checkbox, checked: !checkbox.checked }
        : checkbox
    );

    setCheckboxes(updatedCheckboxes);
  };

  useEffect(() => {
    if (isTodosChecked) {
      const updatedCheckboxes = checkboxes.map((checkbox) => ({
        ...checkbox,
        checked: isTodosChecked,
      }));
      setCheckboxes(updatedCheckboxes);
    } else {
      const updatedCheckboxes = checkboxes.map((checkbox) => ({
        ...checkbox,
        checked: false,
      }));
      setCheckboxes(updatedCheckboxes);
    }

  }, [isTodosChecked])

  function editEmail(email: AtualizaEmailProps) {
    setModal("Editar E-mail", "Email")
    getInfoEmail(email)
  }

  return (
    <div className="my-2">
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="inline-block w-full p-1.5 align-middle">
            <div className="max-h-[150px] overflow-hidden overflow-y-auto rounded-lg border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="sticky top-0 bg-primary ">
                  <tr>
                    <th scope="col" className="th-cadastro">
                      Situação
                    </th>
                    <th scope="col" className="th-cadastro">
                      E-mail
                    </th>
                    <th scope="col" className="th-cadastro">
                      Origem
                    </th>
                    <th scope="col" className="th-cadastro">
                      Acionamento
                    </th>
                    <th scope="col" className="th-cadastro">
                      <div className="flex items-center justify-center ">
                        <img src={editarWhiteIcon} alt="" className="h-5 w-5" />
                      </div>
                    </th>
                    <th >
                      <img src={checkIcon} alt="" className="h-5 w-5" />
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {
                    devedorCadastro?.emails && emails?.length > 0 ? emails.map(email => (
                      <tr key={email.id_email}>
                        <td className="td-cadastro">{email.situacaoemail.toLocaleUpperCase()}</td>
                        <td className="td-cadastro">{email.email}</td>
                        <td className="td-cadastro">{email.origememail}</td>
                        <td className="td-cadastro">
                          <div className="flex items-center justify-center">
                            <img src={greenIcons["email"].icons} alt="" />
                          </div>
                        </td>
                        <td className="td-cadastro">
                          <button
                            className="flex w-full items-center justify-center border-0 bg-transparent outline-none"
                            onClick={() => editEmail(email)}
                          >
                            <img src={editarIcon} alt="" className="h-5 w-5" />
                          </button>
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            className="h-3 w-3 rounded-sm accent-primary"
                            checked={checkboxes[0].checked}
                            onChange={() => handleCheckboxToggle(checkboxes[0].id)}
                          />
                        </td>
                      </tr>
                    )) : <tr>

                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td className="td-cadastro ">

                      </td>
                      <td className="td-cadastro">

                      </td>
                      <td >
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
